import React from 'react';
import './Icons.css';

// SVG Icon Components
export const WaterDropIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C12 2 19 9.44 19 14C19 17.87 15.87 21 12 21C8.13 21 5 17.87 5 14C5 9.44 12 2 12 2Z"/>
  </svg>
);

export const PhoneIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
  </svg>
);

export const EmailIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"/>
  </svg>
);

export const LocationIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5S14.5 7.62 14.5 9S13.38 11.5 12 11.5Z"/>
  </svg>
);

export const ClockIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22S22 17.52 22 12S17.52 2 12 2ZM13 17L8 12.5L9.5 11L13 14.5L17.5 10L19 11.5L13 17Z"/>
  </svg>
);

export const WhatsAppIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382C17.367 14.382 17.188 14.277 16.92 14.067C16.652 13.857 15.547 13.252 15.335 13.175C15.124 13.098 14.971 13.059 14.818 13.329C14.665 13.599 14.146 14.277 14.022 14.431C13.898 14.585 13.773 14.603 13.506 14.467C13.239 14.331 12.327 14.027 11.239 13.079C10.392 12.342 9.82 11.441 9.696 11.172C9.572 10.904 9.682 10.789 9.818 10.654C9.941 10.531 10.089 10.329 10.225 10.205C10.361 10.081 10.401 9.993 10.478 9.839C10.555 9.685 10.517 9.561 10.449 9.425C10.381 9.289 9.82 8.184 9.635 7.645C9.456 7.118 9.272 7.186 9.131 7.178C8.997 7.17 8.844 7.17 8.691 7.17C8.538 7.17 8.289 7.237 8.078 7.507C7.866 7.777 7.204 8.382 7.204 9.486C7.204 10.59 8.039 11.656 8.175 11.81C8.311 11.964 9.82 14.324 12.188 15.292C12.687 15.519 13.076 15.651 13.381 15.746C13.881 15.904 14.336 15.882 14.698 15.813C15.108 15.736 16.022 15.193 16.207 14.599C16.392 14.005 16.392 13.497 16.325 13.382C16.257 13.267 16.104 13.2 15.836 13.064C15.568 12.928 15.372 12.84 15.267 12.735C15.162 12.63 15.1 12.467 15.168 12.331C15.236 12.195 15.797 11.09 15.982 10.551C16.167 10.012 16.353 10.08 16.496 10.088C16.639 10.096 16.792 10.096 16.945 10.096C17.098 10.096 17.347 10.163 17.558 10.433C17.769 10.703 18.431 11.308 18.431 12.412C18.431 13.516 17.596 14.582 17.46 14.736C17.324 14.89 17.472 14.382 17.472 14.382Z"/>
  </svg>
);

export const TrophyIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 4V2C7 1.45 7.45 1 8 1H16C16.55 1 17 1.45 17 2V4H20.38C20.8 4 21.11 4.42 20.96 4.82L19.14 9.88C18.7 11.33 17.38 12.4 15.83 12.75C15.03 14.69 13.31 16.23 11.19 16.76V19H13C13.55 19 14 19.45 14 20S13.55 21 13 21H11C10.45 21 10 20.55 10 20V19H8C7.45 19 7 18.55 7 18S7.45 17 8 17H10V16.76C7.69 16.23 5.97 14.69 5.17 12.75C3.62 12.4 2.3 11.33 1.86 9.88L0.04 4.82C-0.11 4.42 0.2 4 0.62 4H4H7ZM9 6V10.5C9 12.43 10.57 14 12.5 14S16 12.43 16 10.5V6H9Z"/>
  </svg>
);

export const MoneyIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C13.28 6.9 13.94 7.75 14 9H16.21C16.14 7.28 15.09 5.7 13 5.19V3H10V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.44 17.1 8.63 16.18 8.5 15H6.32C6.44 17.19 8.08 18.42 10 18.83V21H13V18.85C14.95 18.5 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.5 11.8 10.9Z"/>
  </svg>
);

export const ShieldIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"/>
  </svg>
);

export const LeafIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22L6.66 19.7C7.14 19.87 7.64 20 8.16 20C10.53 20 12.64 18.83 13.54 16.5C14.44 14.17 13.94 11.5 12.5 9.5C14.36 9.5 16 11.14 16 13V16H18V13C18 9.69 15.31 7 12 7V8.5L9 6L12 3.5V5C16.42 5 20 8.58 20 13V16H22V13C22 7.48 17.52 3 12 3C12 3 17 8 17 8Z"/>
  </svg>
);

export const BusinessIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z"/>
  </svg>
);

export const WrenchIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.7 19L13.6 9.9C14.5 7.6 14 4.9 12.1 3C10.1 1 7.1 0.6 4.7 1.7L9 6L6 9L1.6 4.7C0.4 7.1 0.9 10.1 2.9 12.1C4.8 14 7.5 14.5 9.8 13.6L18.9 22.7C19.3 23.1 19.9 23.1 20.3 22.7L22.6 20.4C23.1 20 23.1 19.3 22.7 19Z"/>
  </svg>
);

export const TargetIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22S22 17.52 22 12S17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12S7.59 4 12 4S20 7.59 20 12S16.41 20 12 20ZM12 6C8.69 6 6 8.69 6 12S8.69 18 12 18S18 15.31 18 12S15.31 6 12 6ZM12 16C9.79 16 8 14.21 8 12S9.79 8 12 8S16 9.79 16 12S14.21 16 12 16ZM12 10C10.9 10 10 10.9 10 12S10.9 14 12 14S14 13.1 14 12S13.1 10 12 10Z"/>
  </svg>
);

export const TelescopeIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.5 12.5C3.5 13.6 4.4 14.5 5.5 14.5S7.5 13.6 7.5 12.5 6.6 10.5 5.5 10.5 3.5 11.4 3.5 12.5M6.8 15.7L12 20.9L17.2 15.7C18 14.9 18 13.6 17.2 12.8L12 7.6L6.8 12.8C6 13.6 6 14.9 6.8 15.7M12 3L18.5 9.5C19.3 10.3 19.3 11.6 18.5 12.4L12 18.9L5.5 12.4C4.7 11.6 4.7 10.3 5.5 9.5L12 3Z"/>
  </svg>
);

export const PersonIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"/>
  </svg>
);

export const PaletteIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3C16.97 3 21 7.03 21 12C21 13.66 20.33 15.64 18 16C17.06 16.05 16 15.2 16 14.2C16 13.7 16.18 13.23 16.5 12.9L18.5 10.9C18.5 10.9 17.45 11.42 16.59 12.28C15.73 13.14 14.88 14 14.5 14C14.12 14 13.27 13.14 12.41 12.28C11.55 11.42 10.5 10.9 10.5 10.9L12.5 12.9C12.82 13.23 13 13.7 13 14.2C13 15.2 11.94 16.05 11 16C8.67 15.64 8 13.66 8 12C8 7.03 12.03 3 17 3Z"/>
  </svg>
);

export const ChartIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"/>
  </svg>
);

export const TeamIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 4C18.2 4 20 5.8 20 8C20 10.2 18.2 12 16 12C13.8 12 12 10.2 12 8C12 5.8 13.8 4 16 4ZM16 14C18.7 14 24 15.3 24 18V20H8V18C8 15.3 13.3 14 16 14ZM8 4C10.2 4 12 5.8 12 8C12 10.2 10.2 12 8 12C5.8 12 4 10.2 4 8C4 5.8 5.8 4 8 4ZM8 14C10.7 14 16 15.3 16 18V20H0V18C0 15.3 5.3 14 8 14Z"/>
  </svg>
);

export const TrendingUpIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"/>
  </svg>
);

export const CheckIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"/>
  </svg>
);

export const CrossIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/>
  </svg>
);

export const StarIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"/>
  </svg>
);

export const AwardIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5 16L3 21L8.5 18L12 21L15.5 18L21 21L19 16H5ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 3C9.24 3 7 5.24 7 8C7 10.76 9.24 13 12 13C14.76 13 17 10.76 17 8C17 5.24 14.76 3 12 3Z"/>
  </svg>
);

export const GlobeIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z"/>
  </svg>
);

export const DocumentIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"/>
  </svg>
);

export const SmartphoneIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2ZM17 18H7V6H17V18Z"/>
  </svg>
);

export const HealthIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H5C3.9 8 3 8.9 3 10V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V10C21 8.9 20.1 8 19 8ZM12 17C10.9 17 10 16.1 10 15S10.9 13 12 13S14 13.9 14 15S13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9S15.1 4.29 15.1 6V8Z"/>
  </svg>
);

export const BrainIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C13.1 2 14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7.5C13 8.33 13.67 9 14.5 9S16 7.83 16 6.5V5.73C15.4 5.39 15 4.74 15 4C15 2.9 15.9 2 17 2S19 2.9 19 4C19 4.74 18.6 5.39 18 5.73V6.5C18 8.99 15.99 11 13.5 11H13V12.5C13 13.33 13.67 14 14.5 14S16 12.83 16 11.5V10.73C15.4 10.39 15 9.74 15 9C15 7.9 15.9 7 17 7S19 7.9 19 9C19 9.74 18.6 10.39 18 10.73V11.5C18 13.99 15.99 16 13.5 16H13V17.5C13 18.33 13.67 19 14.5 19S16 17.83 16 16.5V15.73C15.4 15.39 15 14.74 15 14C15 12.9 15.9 12 17 12S19 12.9 19 14C19 14.74 18.6 15.39 18 15.73V16.5C18 18.99 15.99 21 13.5 21H10.5C8.01 21 6 18.99 6 16.5V15.73C5.4 15.39 5 14.74 5 14C5 12.9 5.9 12 7 12S9 12.9 9 14C9 14.74 8.6 15.39 8 15.73V16.5C8 17.83 8.5 18.33 9.5 19S11 18.33 11 17.5V16H10.5C8.01 16 6 13.99 6 11.5V10.73C5.4 10.39 5 9.74 5 9C5 7.9 5.9 7 7 7S9 7.9 9 9C9 9.74 8.6 10.39 8 10.73V11.5C8 12.83 9.17 14 10.5 14S11 13.33 11 12.5V11H10.5C8.01 11 6 8.99 6 6.5V5.73C5.4 5.39 5 4.74 5 4C5 2.9 5.9 2 7 2S9 2.9 9 4C9 4.74 8.6 5.39 8 5.73V6.5C8 7.83 9.17 9 10.5 9S11 8.33 11 7.5V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2Z"/>
  </svg>
);

export const RunnerIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M13.5 5.5C14.6 5.5 15.5 4.6 15.5 3.5S14.6 1.5 13.5 1.5S11.5 2.4 11.5 3.5S12.4 5.5 13.5 5.5ZM9.8 8.9L7 23H9.1L10.9 15L13 17V23H15V15.5L12.9 13.5L13.5 10.5C14.5 12 16.1 13 18 13V11C16.8 11 15.8 10.3 15.3 9.3L14.5 7.7C14.2 7.1 13.5 6.7 12.8 6.7S11.8 6.9 11.3 7.3L7 10.6V15H9V12.1L9.8 8.9Z"/>
  </svg>
);

export const HospitalIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM13 10H11V12H9V14H11V16H13V14H15V12H13V10Z"/>
  </svg>
);

export const SchoolIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18ZM12 3L1 9L12 15L21 11V17H23V9L12 3Z"/>
  </svg>
);

export const ClockTimeIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M15.71 15.29L11 10.59V7H12.5V10L16.71 14.21L15.71 15.29Z"/>
  </svg>
);

export const BuildingIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M15 11V5L12 2L9 5V7H3V21H21V11H15ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM13 19H11V17H13V19ZM13 15H11V13H13V15ZM13 11H11V9H13V11ZM13 7H11V5H13V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z"/>
  </svg>
);

export const CoffeeIcon = ({ className, size = 24 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M2 21V19H20V21H2ZM20 8H18V5H4V15H16V8H20C21.1 8 22 8.9 22 10V14C22 15.1 21.1 16 20 16H18V14H20V10H18V8ZM18 5V3H4V5H18Z"/>
  </svg>
);
